/** Les sons des appels, servis par le site (`public/sounds`), les mêmes que sur le téléphone. */
const RINGTONE = '/sounds/ringtone.wav';
const RINGBACK = '/sounds/ringback.wav';
const HANGUP = '/sounds/hangup.wav';

/** La vibration d'un appel entrant, là où le navigateur la permet (téléphone). */
const RING_VIBRATION = [900, 1100];

type Tone = 'ringtone' | 'ringback';

let player: HTMLAudioElement | null = null;
let playing: Tone | null = null;
let vibrating: ReturnType<typeof setInterval> | null = null;

/**
 * Les sons d'un appel dans l'onglet : la sonnerie de qui est appelé, la
 * tonalité de retour de qui appelle, deux notes à la fin. Un seul son à la
 * fois ; un navigateur qui refuse de jouer (aucun geste encore dans la page)
 * laisse l'appel s'afficher en silence, il ne le fait jamais échouer.
 *
 * Même contrat que le module du téléphone.
 */
export const ringer = {
  ring(): void {
    start('ringtone', RINGTONE);
    if ('vibrate' in navigator) {
      const pulse = () => navigator.vibrate(RING_VIBRATION);
      pulse();
      vibrating = setInterval(pulse, 2000);
    }
  },

  ringback(): void {
    start('ringback', RINGBACK);
  },

  stop(): void {
    if (vibrating) {
      clearInterval(vibrating);
      vibrating = null;
      navigator.vibrate?.(0);
    }
    playing = null;
    player?.pause();
    player = null;
  },

  hangup(): void {
    ringer.stop();
    void new Audio(HANGUP).play().catch(() => undefined);
  },
};

function start(tone: Tone, source: string): void {
  if (playing === tone) {
    return;
  }
  ringer.stop();
  const audio = new Audio(source);
  audio.loop = true;
  player = audio;
  playing = tone;
  void audio.play().catch(() => undefined);
}
